import { FC } from 'react';
import { SparkleIcon } from '../../svgs';
import TooltipContainer from '../TooltipContainer/TooltipContainer';
import styles from './SuggestionChip.module.scss';

type Props = {
  label: string;
  onClick?: () => void;
  title?: string;
  /**
   * 'ai' is a model suggestion and carries the sparkle; 'exact' is a deterministic
   * name match, which gets a link glyph instead - a sparkle would misattribute it.
   */
  variant?: 'ai' | 'exact';
};

// Rendered as a button so it stays keyboard-accessible; without onClick it is inert.
const SuggestionChip: FC<Props> = ({ label, onClick, title, variant = 'ai' }) => {
  const chip = (tooltipClassName?: string, ref?: any) => (
  <button
    type="button"
    ref={ref}
    className={`${styles.chip} ${variant === 'exact' ? styles.exact : styles.ai} ${tooltipClassName ?? ''}`}
    onClick={onClick ? (e) => { e.stopPropagation(); onClick(); } : undefined}
    disabled={!onClick}
  >
    {variant === 'exact' ? (
      <svg
        className={styles.icon}
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M10 13a5 5 0 007.5.5l3-3a5 5 0 00-7-7l-1.5 1.5" />
        <path d="M14 11a5 5 0 00-7.5-.5l-3 3a5 5 0 007 7l1.5-1.5" />
      </svg>
    ) : (
      <SparkleIcon size="12px" color="var(--gray-500)" withPlus={false} className="suggestion-chip-icon" />
    )}
    <span className={styles.label}>{label}</span>
  </button>
  );

  // Styled tooltip rather than a native title, to match the rest of the app.
  if (!title) return chip();

  return (
    <TooltipContainer renderReferenceComponent={(className, ref) => chip(className, ref)}>
      <div className={styles.tooltip}>{title}</div>
    </TooltipContainer>
  );
};

export default SuggestionChip;
